import { Condition, Rarity, ReputationTier, GAME_CONFIG } from '../types';

export function formatMoney(amount: number): string {
  return '$' + amount.toLocaleString('en-US');
}

export function clamp(value: number, min: number, max: number): number {
  return Math.max(min, Math.min(max, value));
}

export function lerp(a: number, b: number, t: number): number {
  return a + (b - a) * t;
}

export function uid(): string {
  return Date.now().toString(36) + Math.random().toString(36).slice(2, 8);
}

export function getRepTier(rep: number): { tier: ReputationTier; label: string } {
  const tiers = GAME_CONFIG.repTiers;
  for (let i = tiers.length - 1; i >= 0; i--) {
    if (rep >= tiers[i].min) return tiers[i];
  }
  return tiers[0];
}

export function conditionLabel(c: Condition): string {
  return c.charAt(0).toUpperCase() + c.slice(1);
}

export function rarityLabel(r: Rarity): string {
  return r.charAt(0).toUpperCase() + r.slice(1);
}

export function rarityColor(r: Rarity): string {
  switch (r) {
    case 'common': return '#B0B0B0';
    case 'uncommon': return '#4CAF50';
    case 'rare': return '#2196F3';
    case 'legendary': return '#D4A03C';
    case 'mythical': return '#E040FB';
  }
}

export function eraLabel(era: string): string {
  return era.split('_').map(w => w.charAt(0).toUpperCase() + w.slice(1)).join(' ');
}

export function cultureLabel(culture: string): string {
  return culture.split('_').map(w => w.charAt(0).toUpperCase() + w.slice(1)).join(' ');
}

export function delay(ms: number): Promise<void> {
  return new Promise(resolve => setTimeout(resolve, ms));
}
